import { render, staticRenderFns } from "./BidDashboardDeadline.vue?vue&type=template&id=579c5ae6&scoped=true"
import script from "./BidDashboardDeadline.vue?vue&type=script&lang=js"
export * from "./BidDashboardDeadline.vue?vue&type=script&lang=js"
import style0 from "./BidDashboardDeadline.vue?vue&type=style&index=0&id=579c5ae6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579c5ae6",
  null
  
)

export default component.exports